// Enemy wave definitions
// Each wave has: enemyCount, baseHP, damagePerHit, isBoss
export const ENEMY_WAVES = [
  {
    wave: 1,
    enemies: [
      { type: 'grunt', hp: 40, damage: 5, speed: 1.0 }
    ]
  },
  {
    wave: 2,
    enemies: [
      { type: 'grunt', hp: 45, damage: 6, speed: 1.0 },
      { type: 'grunt', hp: 45, damage: 6, speed: 1.0 }
    ]
  },
  {
    wave: 3,
    enemies: [
      { type: 'grunt', hp: 50, damage: 7, speed: 1.1 },
      { type: 'grunt', hp: 50, damage: 7, speed: 1.1 },
      { type: 'grunt', hp: 50, damage: 7, speed: 1.1 }
    ]
  },
  {
    wave: 4,
    enemies: [
      { type: 'elite', hp: 80, damage: 10, speed: 0.9 },
      { type: 'grunt', hp: 55, damage: 8, speed: 1.1 }
    ]
  },
  {
    wave: 5,
    enemies: [
      { type: 'grunt', hp: 60, damage: 9, speed: 1.2 },
      { type: 'grunt', hp: 60, damage: 9, speed: 1.2 },
      { type: 'elite', hp: 90, damage: 12, speed: 0.9 }
    ]
  },
  {
    wave: 6,
    enemies: [
      { type: 'elite', hp: 100, damage: 13, speed: 0.95 },
      { type: 'elite', hp: 100, damage: 13, speed: 0.95 }
    ]
  },
  {
    wave: 7,
    enemies: [
      { type: 'grunt', hp: 70, damage: 12, speed: 1.3 },
      { type: 'elite', hp: 110, damage: 15, speed: 1.0 },
      { type: 'elite', hp: 110, damage: 15, speed: 1.0 }
    ]
  },
  {
    wave: 8,
    isBoss: true,
    enemies: [
      { type: 'boss', hp: 300, damage: 20, speed: 0.8 }
    ]
  }
];

// Get wave configuration
export function getWaveConfig(waveNumber) {
  return ENEMY_WAVES.find(w => w.wave === waveNumber) || ENEMY_WAVES[0];
}
